import { useState } from "react";
import { Field } from "../components/ui";
import { api, errorMessage, type User } from "../lib/api";
import { toast, useSession } from "../lib/app";
import { TopNav } from "./Dashboard";
import { ProfilePicture } from "./ProfilePicture";

export function AccountPage() {
  const { user, setUser, updateSettings } = useSession();
  const [displayName, setDisplayName] = useState(user?.displayName ?? "");
  const [email, setEmail] = useState(user?.email ?? "");
  const [pw, setPw] = useState({ current: "", password: "", confirm: "" });
  if (!user) return null;

  async function saveProfile() {
    try {
      const r = await api.patch<{ user: User }>("/api/me", { displayName, email });
      setUser(r.user);
      toast("Saved", "success");
    } catch (e) {
      toast(errorMessage(e), "error");
    }
  }
  async function changePassword() {
    if (pw.password !== pw.confirm) {
      toast("Passwords don't match", "error");
      return;
    }
    try {
      await api.post("/api/me/password", { current: pw.current, password: pw.password });
      setPw({ current: "", password: "", confirm: "" });
      toast("Password changed. Other sessions were signed out.", "success");
    } catch (e) {
      toast(errorMessage(e), "error");
    }
  }

  return (
    <div className="page">
      <TopNav />
      <main className="page-main" style={{ maxWidth: 560 }}>
        <div className="page-title">
          <h1>Account</h1>
        </div>
        <div className="stack">
          <ProfilePicture />
          <Field label="Username">
            <input value={user.username} disabled />
          </Field>
          <Field label="Display name" hint="Shown on cursors, comments and version history.">
            <input value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
          </Field>
          <Field label="Email" hint="Used as your author email on commits.">
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </Field>
          <div>
            <button className="btn btn-primary" onClick={saveProfile}>
              Save profile
            </button>
          </div>

          <h2 className="section-title">Appearance</h2>
          <Field label="Theme">
            <select value={user.settings.theme ?? "system"} onChange={(e) => updateSettings({ theme: e.target.value as "light" | "dark" | "system" })}>
              <option value="system">System</option>
              <option value="light">Light</option>
              <option value="dark">Dark</option>
            </select>
          </Field>

          <h2 className="section-title">Change password</h2>
          <Field label="Current password">
            <input type="password" autoComplete="current-password" value={pw.current} onChange={(e) => setPw({ ...pw, current: e.target.value })} />
          </Field>
          <Field label="New password" hint="At least 10 characters.">
            <input type="password" autoComplete="new-password" value={pw.password} onChange={(e) => setPw({ ...pw, password: e.target.value })} />
          </Field>
          <Field label="Confirm new password">
            <input type="password" autoComplete="new-password" value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} />
          </Field>
          <div>
            <button className="btn" disabled={!pw.current || !pw.password} onClick={changePassword}>
              Change password
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
